import TimelineItemSingle from "./TimelineItemSingle";
import {max, min} from "d3"

const Timeline = (props) => {

  const titleSectionHeight = 70
  const timelineSectionHeight = props.height-titleSectionHeight
  const timelineSpacer = { top: 10, bottom: 10 };
  const timelineHeight = timelineSectionHeight-timelineSpacer.top-timelineSpacer.bottom
  const timelineInterval = max([timelineHeight / (props.keyEvents.length - 1),65]);
  const timelineInterval2 = min([timelineHeight / (props.keyEvents.length - 1),30])
  let interval = timelineSpacer.top

  return (
    <div
      id="timeline"
      style={{ height: props.height,paddingTop:15,position:"relative"}}
    >
      <div style={{height:titleSectionHeight,position:"absolute",top:0,width:"100%"}}><h4 style={{margin:0,paddingBottom:6}}>Key Developments</h4>
      <div className="flex-center f-smed" id="timeline-subtitles">
        <div className="w-50">
          <p className="mxy-0 px-5" style={{color: "#0d657d"}}>
            <strong>Violent &amp; Military Events</strong>
          </p>
        </div>
        <div className="w-50">
          <p className="mxy-0 px-5" style={{color: "#093746"}}>
            <strong>Demonstrations &amp; Strategic Developments</strong>
          </p>
        </div>
      </div>
      </div>
      <div style={{height: timelineSectionHeight, position:"absolute",top:titleSectionHeight}}>
      <svg height="100%" width="100%">
        <g transform={`translate(${props.width / 2},0)`}>
          <line
            x1={0}
            x2={0}
            y1={0}
            y2={
              timelineHeight +
              timelineSpacer.top +
              timelineSpacer.bottom
            }
            strokeWidth="2px"
            stroke="#898989"
          />
        </g>
      </svg>
      {props.keyEvents.map((item, index) => {
      if (index>0){ 
        let increment = item.event_type === props.keyEvents[index-1].event_type ? timelineInterval : timelineInterval2
        interval += increment
      }
        return (
          <TimelineItemSingle
            key={index}
            width={props.width}
            timelineInterval={interval}
            timelineSpacer={timelineSpacer}
            item={item}
            index={index}
            setPositionHandler={props.setPositionHandler}
          />
        );
      })}
      </div>
    </div>
  );
};

export default Timeline;
